import bind from 'lodash/bind';
import { Authenticator, AuthenticatorOptions, AuthStrategyOptions } from './Authenticator';
import { fetchUserFn } from './viddseeLoginController/userFetcher';
import { VsAuthenticatorStorage } from './viddseeLoginController/AuthenticatorStorage';
import webcall from '@/scripts/webcall';
import { facebookLoginStrategy } from './viddseeLoginController/strategies/facebook';
import { emailLoginStrategy } from './viddseeLoginController/strategies/email';
import { googleLoginStrategy } from './viddseeLoginController/strategies/google';

type ExtractStrategyAsMethodDict<T extends AuthenticatorOptions<AuthStrategyOptions>> = {
  [K in keyof T['strategy']]: (params: Parameters<T['strategy'][K]['login']>[0]) => ReturnType<T['strategy'][K]['login']>
}

/**
 * VsAuthenticator extends Authenticator to provide backward compatibility support for legacy codes
 */
export class VsAuthenticator<T extends AuthenticatorOptions<AuthStrategyOptions>> extends Authenticator<T> {
  /**
 * @deprecated Use loginController.getUser instead
 */
  async checkLoginStatus(callback: (status: 'signed_in' | 'not_signed_in') => any): Promise<void> {
    const user = await this.getUser();
    const status = user ? 'signed_in' : 'not_signed_in';
    callback(status);
  };

  /**
   * @deprecated Use loginController.getUser instead.
   * Avoid using this to check if a user is logged in or not.
   * This method does not verify access_token. It merely
   * check for existence of access_token in localStorage.
   */
  checkLogin(): boolean {
    return !!this.token;
  };

  get methods(): ExtractStrategyAsMethodDict<T> {
    return Object.keys(this.options.strategy)
      .reduce((acc, name) => {
        acc[name] = bind(this.loginWith, this, name);
        return acc;
      }, {} as any)
    ;
  }
}

const loginController = new VsAuthenticator({
  strategy: {
    facebook: {
      login: facebookLoginStrategy,
    },
    email: {
      login: emailLoginStrategy,
    },
    google: {
      login: googleLoginStrategy,
    },
  },
  storage: new VsAuthenticatorStorage(),
  handler: {
    fetchUser: fetchUserFn,
    logout: webcall.user.logout,
  },
});

export default loginController;
